export default "__VITE_ASSET__BeHE_G99__"